import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaCid.vue?vue&type=template&id=4e620f89&scoped=true"
import script from "./ModalSolicitacaoCirurgiaCid.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaCid.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaCid.vue?vue&type=style&index=0&id=4e620f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e620f89",
  null
  
)

export default component.exports